import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { ReactComponent as Trash } from '../../Img/icon-white-trash.svg';
import { addSpace } from '../../Components/Tools';
import Dialog from "../../Components/Dialog";
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import { ReactComponent as Add } from '../../Img/icon-add.svg';

const GrilleTableauBord = (props) =>
{
    const heightObject = window.innerHeight/1.7;
    const [aff, setAff] = useState(false);
    const [dmToSuppress, setDmToSuppress] = useState(null);

    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';
    const smoothGrey = '#f4f4f4';

    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    
    async function callbackDialog(ret) {
        if (ret === true) {
            if (dmToSuppress !== null) {
                await suppressDM(dmToSuppress);
            }
        }
        await setDmToSuppress(null);
    }

    async function calculTotaux()
    {
        var tmp = props.objet;

        /* Initialisation des lignes totaux à 0 */
        await tmp.forEach(async(line, i) => {
            if (line.matrice.matricule === '2014M57REELDEBFCT'
                || line.matrice.matricule === '2014M57REELCREFCT'
                || line.matrice.matricule === '2014M57REELDEBINV'
                || line.matrice.matricule === '2014M57REELCREINV'
                || line.matrice.matricule === "2014M5720 + 2014M5721 + 2014M5723 + 2014M5745")
            {
                tmp[i].budget_primitif = 0;
                tmp[i].total_vote = 0;
                tmp[i].janvier = 0;
                tmp[i].fevrier = 0;
                tmp[i].mars = 0;
                tmp[i].avril = 0;
                tmp[i].mai = 0;
                tmp[i].juin = 0;
                tmp[i].juillet = 0;
                tmp[i].aout = 0;
                tmp[i].septembre = 0;
                tmp[i].octobre = 0;
                tmp[i].novembre = 0;
                tmp[i].decembre = 0;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        tmp[i][dmKey] = 0;
                    }
                }
            }
        });

        /* Calcul des totaux */
        await tmp.forEach(async(line, i) => {
            if (line.matrice.matricule === '2014M57011'
                || line.matrice.matricule === '2014M57012'
                || line.matrice.matricule === '2014M5765 - 2014M57656'
                || line.matrice.matricule === '2014M57014'
                || line.matrice.matricule === '2014M5766'
                || line.matrice.matricule === 'AUTRESDEPFCT')
            {
                tmp[1].budget_primitif += tmp[i].budget_primitif;
                tmp[1].total_vote += tmp[i].total_vote;
                tmp[1].janvier += tmp[i].janvier;
                tmp[1].fevrier += tmp[i].fevrier;
                tmp[1].mars += tmp[i].mars;
                tmp[1].avril += tmp[i].avril;
                tmp[1].mai += tmp[i].mai;
                tmp[1].juin += tmp[i].juin;
                tmp[1].juillet += tmp[i].juillet;
                tmp[1].aout += tmp[i].aout;
                tmp[1].septembre += tmp[i].septembre;
                tmp[1].octobre += tmp[i].octobre;
                tmp[1].novembre += tmp[i].novembre;
                tmp[1].decembre += tmp[i].decembre;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        if (!tmp[1][dmKey]) {
                            tmp[1][dmKey] = 0;
                        }
                        tmp[1][dmKey] += tmp[i][dmKey];
                    }
                }
            }
            // Calcul des totaux pour les depenses d'equipement
            if (line.matrice.matricule === "2014M5720 - 2014M57204"
                || line.matrice.matricule === '2014M5721'
                || line.matrice.matricule === '2014M5723'
                || line.matrice.matricule === '2014M5745')
            {
                tmp[24].budget_primitif += tmp[i].budget_primitif;
                tmp[24].total_vote += tmp[i].total_vote;
                tmp[24].janvier += tmp[i].janvier;
                tmp[24].fevrier += tmp[i].fevrier;
                tmp[24].mars += tmp[i].mars;
                tmp[24].avril += tmp[i].avril;
                tmp[24].mai += tmp[i].mai;
                tmp[24].juin += tmp[i].juin;
                tmp[24].juillet += tmp[i].juillet;
                tmp[24].aout += tmp[i].aout;
                tmp[24].septembre += tmp[i].septembre;
                tmp[24].octobre += tmp[i].octobre;
                tmp[24].novembre += tmp[i].novembre;
                tmp[24].decembre += tmp[i].decembre;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        if (!tmp[1][dmKey]) {
                            tmp[1][dmKey] = 0;
                        }
                        tmp[1][dmKey] += tmp[i][dmKey];
                    }
                }
            }
            if (line.matrice.matricule === '2014M5770'
                || line.matrice.matricule === '2014M5773'
                || line.matrice.matricule === '2014M5774'
                || line.matrice.matricule === '2014M5775'
                || line.matrice.matricule === '2014M57775'
                || line.matrice.matricule === 'AUTRESRECFCT')
            {
                tmp[9].budget_primitif += tmp[i].budget_primitif;
                tmp[9].total_vote += tmp[i].total_vote;
                tmp[9].janvier += tmp[i].janvier;
                tmp[9].fevrier += tmp[i].fevrier;
                tmp[9].mars += tmp[i].mars;
                tmp[9].avril += tmp[i].avril;
                tmp[9].mai += tmp[i].mai;
                tmp[9].juin += tmp[i].juin;
                tmp[9].juillet += tmp[i].juillet;
                tmp[9].aout += tmp[i].aout;
                tmp[9].septembre += tmp[i].septembre;
                tmp[9].octobre += tmp[i].octobre;
                tmp[9].novembre += tmp[i].novembre;
                tmp[9].decembre += tmp[i].decembre;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        if (!tmp[9][dmKey]) {
                            tmp[9][dmKey] = 0;
                        }
                        tmp[9][dmKey] += tmp[i][dmKey];
                    }
                }
            }
            if (line.matrice.matricule === '2014M5716'
                || line.matrice.matricule === '2014M5720 - 2014M57204'
                || line.matrice.matricule === '2014M57204'
                || line.matrice.matricule === '2014M5721'
                || line.matrice.matricule === '2014M5723'
                || line.matrice.matricule === '2014M5745'
                || line.matrice.matricule === 'AUTRESDEPINV')
            {
                tmp[17].budget_primitif += tmp[i].budget_primitif;
                tmp[17].total_vote += tmp[i].total_vote;
                tmp[17].janvier += tmp[i].janvier;
                tmp[17].fevrier += tmp[i].fevrier;
                tmp[17].mars += tmp[i].mars;
                tmp[17].avril += tmp[i].avril;
                tmp[17].mai += tmp[i].mai;
                tmp[17].juin += tmp[i].juin;
                tmp[17].juillet += tmp[i].juillet;
                tmp[17].aout += tmp[i].aout;
                tmp[17].septembre += tmp[i].septembre;
                tmp[17].octobre += tmp[i].octobre;
                tmp[17].novembre += tmp[i].novembre;
                tmp[17].decembre += tmp[i].decembre;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        if (!tmp[17][dmKey]) {
                            tmp[17][dmKey] = 0;
                        }
                        tmp[17][dmKey] += tmp[i][dmKey];
                    }
                }
            }
            if (line.matrice.matricule === '2014M5710 - 2014M571068'
                || line.matrice.matricule === '2014M5713'
                || line.matrice.matricule === 'Emprunts nouveaux'
                || line.matrice.matricule === 'AUTRESRECINV')
            {
                tmp[27].budget_primitif += tmp[i].budget_primitif;
                tmp[27].total_vote += tmp[i].total_vote;
                tmp[27].janvier += tmp[i].janvier;
                tmp[27].fevrier += tmp[i].fevrier;
                tmp[27].mars += tmp[i].mars;
                tmp[27].avril += tmp[i].avril;
                tmp[27].mai += tmp[i].mai;
                tmp[27].juin += tmp[i].juin;
                tmp[27].juillet += tmp[i].juillet;
                tmp[27].aout += tmp[i].aout;
                tmp[27].septembre += tmp[i].septembre;
                tmp[27].octobre += tmp[i].octobre;
                tmp[27].novembre += tmp[i].novembre;
                tmp[27].decembre += tmp[i].decembre;
                for (let j = 1; j <= 20; j++) {
                    const dmKey = `DM${j}`;
                    if (tmp[i][dmKey]) {
                        if (!tmp[27][dmKey]) {
                            tmp[27][dmKey] = 0;
                        }
                        tmp[27][dmKey] += tmp[i][dmKey];
                    }
                }
            }
        });
        await props.setObjet(tmp);
        await setAff(!aff)
    }


    async function suppressDM(DM)
    {
        var tmp = props.objet
        await tmp.forEach(async(line, i) => {
            if (line[DM]) {
                await props.updateObjet(line.matrice.matricule, DM, 0, 'totalVote', props.DM)
            }
        });
        await validation('notnotif')
        if (props.DM.length > 0 && parseInt(DM.slice(2)) === props.DM[props.DM.length - 1]) {
            if (props.DM.length === 1) {
                await props.setDM([0])
            }
            else {
                await props.DM.pop()
            }
        }
        await setAff(!aff)
    }



    async function validation(notnotif = '')
    {
        const params = {
            'set_datas': true,
            'id_budget': props.user.id_budget,
            'annee': props.annee,
            'mois': props.mois,
            'DM': props.DM,
            'objet': props.objet
        };
        axios.post('https://app-slfinance.fr/api/tableau_bord.php', qs.stringify(params))
        .then(async(res) => {
            await props.setAlertCloseWindow(false)
            if (notnotif !== 'notnotif') {
                if (res.data.status === 1) {
                    await NotificationManager.success(res.data.status_message, '', 700);
                }
                else {
                    await NotificationManager.warning(res.data.status_message, '', 3000);
                }
            }
        })
        .catch(error => {
            console.log("Access: ", error)
        })
    }


	return (
        <div>
            <div style={{display: 'flex'}}>

                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                {/* Bouton pour ajouter un DM */}
                {props.user && props.user.droits.tdb_saisie.includes('M') &&
                <div style={{marginLeft: 20, display: 'flex', alignItems: 'center'}}>
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={{backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20}}
                        onClick={async () => {
                            var tmp = props.DM
                            tmp[tmp.length] = tmp[tmp.length-1] + 1
                            props.setDM(tmp)
                            await setAff(!aff)
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Add width="12" />
                            <p style={{margin: 5}}>Ajouter une Décision modificative</p>
                        </div>
                    </button>
                </div>
                }

                <div style={{flex: 1}}></div>

                {/* Bouton pour valider la grille */}

                {props.user && props.user.droits.tdb_saisie.includes('M') &&
                <div style={{marginRight: 20}}>
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={{backgroundColor: green, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20}}
                        onClick={async () => {
                            await validation()
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Check width="12" />
                            <p style={{margin: 5}}>Valider</p>
                        </div>
                    </button>
                </div>
                }
            </div>
            

            {/* Grille */}
            <div className='shadow-xl rounded-md' style={{margin: 20}}>
                
                {/* Premiere ligne Intitulé des colones */}
                <div style={{overflowY: 'scroll', textAlign: 'center'}}>
                    <div style={{flex: 1, borderTop: '1px solid white', display: 'flex'}}>
                        
                        <div style={{flex: 2, backgroundColor: blue, display: 'flex', textAlign: 'right', minHeight: 28, minWidth: 200}}>
                        </div>

                        <div style={{flex: 0.5, backgroundColor: blue, borderLeft: '1px solid white', width: 100, padding: 2}}>
                            <p style={{color: 'white', fontSize: 18, marginLeft: 5}}>Budget primitif</p>
                        </div>

                        {/* Liste des DM */}
                        {props.DM.map((index, l) =>
                        index > 0?
                        <div key={l} style={{flex: 0.5, backgroundColor: blue, borderLeft: '1px solid white', width: 100, padding: 2, display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}></div>
                            <p style={{color: 'white', fontSize: 18, marginRight: 5}}>DM{index}</p>
                            <button
                            onClick={async () => {
                                await setDmToSuppress('DM'+index);
                                await setDialogModalVisible(true);
                                // suppressDM('DM'+index)
                            }}>
                                <Trash />
                            </button>
                            <div style={{flex: 1}}></div>
                        </div>:null)}

                        <div style={{flex: 0.5, backgroundColor: blue, borderLeft: '1px solid white', width: 100, padding: 2}}>
                            <p style={{color: 'white', fontSize: 18, marginLeft: 5}}>Total voté</p>
                        </div>

                        <div style={{flex: 0.5, backgroundColor: blue, borderLeft: '1px solid white', width: 100, padding: 2}}>
                            <p style={{color: 'white', fontSize: 18, marginLeft: 5}}>{props.frontMonth}</p>
                        </div>
                    </div>
                </div>

                {/* Liste de la grille avec les données */}
                <div style={{overflowY: 'scroll', maxHeight: heightObject}}>
                    {props.objet.map((line, i) =>
                    <div key={i} style={{flex: 1, borderTop: '1px solid white', display: 'flex'}}>
                        
                        {line.matrice.chapitre === "0"?
                        <div style={i%2===0?{flex: 2, display: 'flex', textAlign: 'right', minHeight: 28, minWidth: 200, backgroundColor: smoothGrey}:{flex: 2, display: 'flex', textAlign: 'right', minHeight: 28, minWidth: 200, backgroundColor: 'white'}}>
                            <p style={{color: 'red', minWidth: 100}}>{line.matrice.compte}</p>
                            <p style={{marginLeft: 10}}>{line.matrice.intitule}</p>
                        </div>
                        :
                        <div style={{flex: 2, padding: 3, backgroundColor: blue}}>
                            <p style={{color: 'white', fontSize: 18, marginLeft: 5}}>{line.matrice.intitule}</p>
                        </div>
                        }
                        
                        {/* Budget Primitif */}
                        {line.matrice.chapitre != '1'?
                        <input
                            style={i%2===0?{flex: 0.5, textAlign: 'right', borderLeft: '1px solid white', width: 100, padding: 2, backgroundColor: smoothGrey}:{flex: 0.5, textAlign: 'right', borderLeft: '1px solid #f4f4f4', width: 100, padding: 2, backgroundColor: 'white'}}
                            onBlur={async(e) =>{
                                if (e.target.value !== '' && e.target.value !== null) {
                                    await props.setAlertCloseWindow(true);
                                    var value = parseFloat(e.target.value)
                                    if (value || value === 0) {
                                        await props.updateObjet(line.matrice.matricule, 'budget_primitif', value, 'totalVote', props.DM);
                                        e.target.value = '';
                                        await calculTotaux();
                                        await setAff(!aff);
                                    }
                                }
                            }}
                            placeholder={line.budget_primitif?addSpace(line.budget_primitif, true):''}
                        />
                        :null}


                        {/* DM */}
                        {line.matrice.chapitre != '1'?
                            props.DM.map((elem, k) =>
                            elem > 0?
                            <input
                                key={k}
                                style={i%2===0?{flex: 0.5, textAlign: 'right', borderLeft: '1px solid white', width: 100, padding: 2, backgroundColor: smoothGrey}:{flex: 0.5, textAlign: 'right', borderLeft: '1px solid #f4f4f4', width: 100, padding: 2, backgroundColor: 'white'}}
                                placeholder={line['DM'+elem]?addSpace(line['DM'+elem], true):''}
                                onBlur={async(e) =>{
                                    if (e.target.value !== '' && e.target.value !== null) {
                                        await props.setAlertCloseWindow(true);
                                        var value = parseFloat(e.target.value);
                                        if (value || value === 0) {
                                            await props.updateObjet(line.matrice.matricule, 'DM'+elem, value, 'totalVote', props.DM);
                                            e.target.value = '';
                                            await calculTotaux();
                                            await setAff(!aff);
                                        }
                                    }
                                }}
                            />
                            :null)
                        :null}
                        
                        {/* Total Voté */}
                        {line.matrice.chapitre != '1'?
                        <input
                            style={i%2===0?{flex: 0.5, textAlign: 'right', borderLeft: '1px solid white', width: 100, padding: 2, backgroundColor: smoothGrey}:{flex: 0.5, textAlign: 'right', borderLeft: '1px solid #f4f4f4', width: 100, padding: 2, backgroundColor: 'white'}}
                            onBlur={async(e) =>{
                                if (e.target.value !== '' && e.target.value !== null) {
                                    await props.setAlertCloseWindow(true);
                                    var value = parseFloat(e.target.value);
                                    if (value || value === 0) {
                                        await props.updateObjet(line.matrice.matricule, 'total_vote', value);
                                        e.target.value = '';
                                        await calculTotaux();
                                        await setAff(!aff);
                                    }
                                }
                            }}
                            placeholder={line.total_vote?addSpace(Math.round(line.total_vote*100)/100, true):''}
                        />
                        :null}

                        {/* MOIS */}
                        {line.matrice.chapitre != '1'?
                        <input
                            style={i%2===0?{flex: 0.5, textAlign: 'right', borderLeft: '1px solid white', width: 100, padding: 2, backgroundColor: smoothGrey}:{flex: 0.5, textAlign: 'right', borderLeft: '1px solid #f4f4f4', width: 100, padding: 2, backgroundColor: 'white'}}
                            placeholder={line[props.mois]?addSpace(line[props.mois], true):''}
                            onBlur={async(e) =>{
                                if (e.target.value !== '' && e.target.value !== null) {
                                    await props.setAlertCloseWindow(true);
                                    var value = parseFloat(e.target.value);
                                    if (value || value === 0) {
                                        await props.updateObjet(line.matrice.matricule, props.mois, value);
                                        e.target.value = '';
                                        await calculTotaux();
                                        await setAff(!aff);
                                    }
                                }
                            }}
                        />
                        :null}
                    </div>
                    )}

                </div>

            </div>
        </div>
	);
}

export default GrilleTableauBord;
